import React from "react"
import { Currency } from "../../util/numbers"
import { td, tdLabel } from "./constants"

interface Props {
  userName: string
  userEmail: string
  remainingBandShare: number
}

const OwnerRow: React.FC<Props> = ({ userName, userEmail, remainingBandShare }) => (
  <tbody className="border-t-2 border-black">
    <tr>
      <td className={tdLabel}>Your Payout Dist</td>

      {/* Desktop: name and email each in their own column */}
      <td className={`${td} hidden lg:table-cell`}>{userName}</td>
      <td className={`${td} hidden lg:table-cell`}>{userEmail}</td>
      <td className={`${td} hidden lg:table-cell`} />

      {/* Mobile: name and email stacked in one column */}
      <td className={`${td} table-cell lg:hidden`} colSpan={3}>
        <div>{userName}</div>
        <div className="text-gray-600 text-xs">{userEmail}</div>
      </td>

      <td className={`${td} text-right font-bold`}>{Currency(remainingBandShare)}</td>
    </tr>
  </tbody>
)

export default OwnerRow
